import { COLORS } from '@/constants';
import styled from 'styled-components';

export const TagBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 28px;
  gap: 4px;
  border-radius: 4px;
  background: ${COLORS['white']};
  padding: 2px 6px;
  cursor: default;

  z-index: 20;
  position: absolute;
  top: 8px;
  left: 8px;

  border-radius: 6px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #d4d4d4;
  background: #ffffff80;
  color: ${COLORS["primary/900"]};
`;
